import { Clock, User, MapPin, CalendarDays } from "lucide-react";
import { StatusChip, EmptyState } from "./common";
import { fmtDateLong } from "../lib/format";

export function FicheSessions({ sessions = [] }) {
  if (!sessions.length) return <EmptyState icon={CalendarDays} title="Aucun cours planifié" text="Inscrivez l'élève à un cours depuis le Planning." />;
  const futurs = sessions.filter((s) => s.statut !== "passe");
  const passes = sessions.filter((s) => s.statut === "passe").reverse();
  const Row = ({ s }) => (
    <li className="flex flex-wrap items-center justify-between gap-2 px-4 py-2.5">
      <div className="min-w-0">
        <p className="text-sm font-medium">{s.module_nom}</p>
        <p className="text-xs text-muted-foreground flex flex-wrap gap-x-3">
          <span className="capitalize">{fmtDateLong(s.date)}</span>
          <span className="flex items-center gap-1 tabular-nums"><Clock size={11} />{s.heure_debut} – {s.heure_fin}</span>
          {s.formateur_nom && <span className="flex items-center gap-1"><User size={11} />{s.formateur_nom}</span>}
          {s.salle && <span className="flex items-center gap-1"><MapPin size={11} />{s.salle}</span>}
        </p>
      </div>
      <StatusChip statut={s.statut} />
    </li>
  );
  return (
    <div className="space-y-4">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-1.5 px-1">À venir ({futurs.length})</p>
        <ul className="rounded-xl border border-border bg-card divide-y divide-border">{futurs.length ? futurs.map((s) => <Row key={s.id} s={s} />) : <li className="px-4 py-3 text-sm text-muted-foreground">Aucun cours à venir</li>}</ul>
      </div>
      {passes.length > 0 && (
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground mb-1.5 px-1">Passés ({passes.length})</p>
          <ul className="rounded-xl border border-border bg-card divide-y divide-border">{passes.map((s) => <Row key={s.id} s={s} />)}</ul>
        </div>
      )}
    </div>
  );
}
